import * as React from "react"
import { Domain, NPKCatalogs } from "@smartdevis/server/src/domain"
import { i18n } from "../../../services/translations"
import { SMap, toMap } from "@smartdevis/utils/src/map"
import { identity } from "@smartdevis/utils/src/misc"
import { F0 } from "@smartdevis/utils/src/types"
import { genTemporaryId } from "@smartdevis/utils/src/id"
import { NpkCatalogsLogin } from "../npk-catalogs/npk-catalogs-login"
import { asyncConnect } from "../../../resolvers"
import { IncompletePosition, attachNPKCatalogToPosition, mkCatalogPositionStyledSchema, mkIncompletePosition, mkNPKPositionSchema, renderCatalogPosition, renderCatalogPositionHeader } from "../devis-positions/DevisPosition.helpers"
import { getCurrentYear } from "@smartdevis/utils/src/date"
import { getDummyCatalogVersion } from "../lists/PositionsList"
import { MutationManagement } from "../../../utils/devisHelpers"
import { NPKCatalogPicker } from "./helper/crb-catalog-picker"

type CRBModeProps = {
    closeCRBMode: F0
    // below props should be removed
    crbCatalogPosition: IncompletePosition | null
    sortedSublevels: SMap<Domain.Sublevel[]>
    devis: Pick<Domain.Devis, "devisId" | "shelfVersion">
    sm: MutationManagement<"sections", Domain.Section>
    subsm: MutationManagement<"sections", Domain.Section>
}



export const CRBCatalog: React.FC<CRBModeProps> = asyncConnect({
    stateResolvers: ["CRBAccessAuth", "auth", "NPKUnits"],
    actions: ["logon", "fetchNPKUnits"]
})(p => {
    const { auth } = p;
    const [credentials, setCredentials] = React.useState<NPKCatalogs.Credentails>({} as NPKCatalogs.Credentails);

    const [status, setStatus] = React.useState<NPKCatalogs.AccessStatus>({ status: -1, message: "" });
    const [NPKunits, setNPKUnits] = React.useState<NPKCatalogs.NPKUnits[]>([]);
    const [navigation, setNavigation] = React.useState<NPKCatalogs.ChapterRef>({
        language: "Deutsch",
        version: getCurrentYear(),
        number: "",
        chapterTitle: "",
        snumber: "",
        wdNumber: "",
        workDescriptiom: null
    } as NPKCatalogs.ChapterRef);

    React.useEffect(()=>{
        console.warn('navigation',navigation);
    },[navigation])

    React.useEffect(() => {
        if (p.CRBAccessAuth.type === "Fetched") {
            p.fetchNPKUnits({
                language: navigation.language,
                year: navigation.version.toString()
            })
        }
    }, [p.CRBAccessAuth])

    React.useEffect(() => {
        if (p.NPKUnits.type === "Fetched") {
            setNPKUnits(p.NPKUnits.value);
        }
    }, [p.NPKUnits])

    return status.status === -1 ?
        <NpkCatalogsLogin
            visible
            credentials={credentials}
            setCredentials={(credentials) => setCredentials(credentials)}
            onClose={p.closeCRBMode}
            auth={auth}
            CRBAuthStatus={status}
            setCRBAuthStatus={(status) => setStatus(status)}
        /> :
        <NPKCatalogPicker
            visible

            credentials={credentials}
            setCredentials={status => setCredentials(status)}
            auth={auth}
            shelfType="positions"

            navigation={navigation}
            setNavigation={nav => setNavigation(nav)}

            itemsToPreview={toMap(
                p.sortedSublevels[p.crbCatalogPosition!.sectionId]?.filter(
                    sl => sl.basedOn === "position"
                ) as Domain.Position[],
                v => v.positionId,
                identity
            )}
            previewTitle={
                i18n(
                    "Preview: $1",
                    { ...p.sm.allItems, ...p.subsm.allItems }[p.crbCatalogPosition!.sectionId]?.name || ""
                )}
            renderItem={renderCatalogPosition}
            renderHeader={renderCatalogPositionHeader}
            onClose={p.closeCRBMode}
            // projectId={projectId}
            shelfVersion={p.devis.shelfVersion ? p.devis.shelfVersion : getDummyCatalogVersion}
            item={{} as IncompletePosition}
            getItemId={pos => pos.positionId}
            mkNewItem={({ sectionId }) => mkIncompletePosition(sectionId, p.devis.devisId, p.sortedSublevels[sectionId]?.length || 0)}
            mkCopyItem={pos => ({
                ...pos,
                positionId: genTemporaryId(),
                order: p.sortedSublevels[pos.sectionId]?.length || 0
            })}
            attachCatalog={attachNPKCatalogToPosition}
            mkSchema={() => mkNPKPositionSchema("weak", NPKunits)}
            mkInitial={identity}
            mkStyledSchema={mkCatalogPositionStyledSchema}
            onSubmit={s1 => {
                // p.pm.allItems[s1.positionId] && isOk(runValidatorsRaw([validatePosition], s1))
                //     ? p.pm.onItemSubmit(s1 as Domain.Position)({})
                //     : p.pm.setUnsavedItem(s1 as Domain.Position)
            }}
            onRemove={position => {
                // p.pm.onItemRemove(position as Domain.Position)()
            }}
        />
});
